import { IServiceQualificationResponse, SERVICEABILITY_STATUS } from '@belong/types';

/**
 * return serviceability status returned by adsq endpoint
 */
export const getServiceabilityOutcome = (response: IServiceQualificationResponse): SERVICEABILITY_STATUS => {
  return SERVICEABILITY_STATUS[response.serviceQualification?.status ?? 'SOMETHING_WENT_WRONG'];
};
